var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useState, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { appSelectors } from 'redux/ducks/app';
import { hadSelectors } from 'reports/had/redux/ducks/had';
import useBentoBoxModal from 'components/common/bento-box-modal/useBentoBoxModal';
import { REPORT_TITLE } from 'constants/app.constant';
var useHADPageNavigatorModal = function (_a) {
    var isHesiReadinessApp = _a.isHesiReadinessApp;
    var _b = useState(false), showCourseSelectionModal = _b[0], setShowCourseSelectionModal = _b[1];
    var hadPrograms = useSelector(hadSelectors.getPrograms);
    var selectedCourse = useSelector(appSelectors.getSelectedCourse);
    var courses = useSelector(appSelectors.getCourses);
    var handleCourseSelectionModal = function () {
        setShowCourseSelectionModal(!showCourseSelectionModal);
    };
    var _c = useBentoBoxModal({
        courses: courses,
        isHesiReadinessApp: isHesiReadinessApp,
        hadPrograms: hadPrograms,
        handleCourseSelectionModal: handleCourseSelectionModal
    }), isCWDisable = _c.isCWDisable, isEHRDisable = _c.isEHRDisable, onEHRNavigation = _c.onEHRNavigation, onHADNavigation = _c.onHADNavigation, onCWNavigation = _c.onCWNavigation, handleRedirectPage = _c.handleRedirectPage;
    var navItems = useMemo(function () { return [
        __assign(__assign({}, REPORT_TITLE.SHERPATH_PERFORMANCE_GRADES), { icon: 'learning-competency', isDisable: isCWDisable, onClick: onCWNavigation }),
        __assign(__assign({}, REPORT_TITLE.HESI_SPECIALTY_EXAM_READINESS), { icon: 'psychology', isDisable: isEHRDisable, onClick: onEHRNavigation }),
        __assign(__assign({}, REPORT_TITLE.READINESS_DASHBOARD), { icon: 'empowering-knowledge-c', isDisable: true }),
        __assign(__assign({}, REPORT_TITLE.HESI_NCLEX_READINESS), { icon: 'machine-learning--hover', isDisable: false, onClick: onHADNavigation })
    ]; }, [isCWDisable, isEHRDisable, onCWNavigation, onEHRNavigation, onHADNavigation]);
    var courseSelectionModalProps = {
        onCloseModal: handleCourseSelectionModal,
        courseSections: courses,
        initialCourseId: selectedCourse,
        handleRedirectPage: handleRedirectPage
    };
    return {
        courseSelectionModalProps: courseSelectionModalProps,
        navItems: navItems,
        handleCourseSelectionModal: handleCourseSelectionModal,
        showCourseSelectionModal: showCourseSelectionModal
    };
};
export default useHADPageNavigatorModal;
